import React from 'react';
import classNames from 'classnames';
import styles from './AiTemplatesModal.module.css';

const Category: React.FC<{
  category: string;
  selected: boolean;
  onClick: (category: string) => void;
}> = ({ category = '', selected = false, onClick }) => (
  <div
    className={classNames(styles.filterItem, {
      [styles.filterItemSelected]: selected,
    })}
    onClick={() => onClick(category)}
  >
    {category === 'Global All' ? 'All' : category}
  </div>
);

export default Category;
